'use client';

import { Check, TriangleAlert } from 'lucide-react';

import { clsx } from 'clsx';
import { useRouter } from 'next/navigation';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { CloseIcon } from '@shared/ui/CloseIcon';
import { Modal } from '@shared/ui/Modal';
import { closeAlert } from '@widgets/AlertModal';

import cls from './AlertModal.module.scss';

export const AlertModal = () => {
  const isOpen = useAppSelector((state) => state.alert.isOpen);
  const data = useAppSelector((state) => state.alert.data);
  const variant = useAppSelector((state) => state.alert.variant);
  const button = useAppSelector((state) => state.alert.data.button);
  const { push } = useRouter();

  const dispatch = useAppDispatch();

  const onCloseHandler = () => {
    dispatch(closeAlert());
  };

  const clickHandler = () => {
    if (button?.link) {
      push(button?.link);
    }
  };

  const mods: Record<string, string | boolean | undefined> = {
    [cls.success]: variant === 'success',
    [cls.error]: variant === 'error'
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseHandler}
      contentClassName={cls.wrap}
    >
      <div
        role={'alert'}
        className={clsx(cls.alert, mods)}
      >
        <CloseIcon
          className={cls.close}
          testId={'alert-modal-close-button'}
          onClick={onCloseHandler}
        />
        <div className={cls.icon}>{variant === 'error' ? <TriangleAlert /> : <Check />}</div>
        <h3 className={cls.title}>{data.title}</h3>
        <div className={cls.text}>{data.text}</div>
        {button && (
          <Button
            testId={'alert-modal-button'}
            aria-label={button.text}
            onClick={clickHandler}
            className={cls.button}
          >
            {button.text}
          </Button>
        )}
      </div>
    </Modal>
  );
};
